// imports
import Component from 'minsky-kit/js/components/Component';

// class definition
export default class Accordion extends Component {
    // constructor
    constructor (args = {}, objectName = 'Accordion') {
        // super
        super(args, objectName);
        this.title = null;

        this.state = 'closed';

        this.listener = null;

        this.setup();
    }

    setup () {
        this.title = this.$el.querySelector('.accordion__title');

        this.listener = this.title.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.state === 'open') {
                this.close();
            }
            else {
                this.open();
            }
        });

        if (this.state === 'closed') {
            this.close(true);
        }
    }

    close (hard = false) {
        this.$el.classList.add('closed');
        this.$el.classList.remove('open');
        gsap.to(this.$el, { height: this.title.offsetHeight, duration: hard ? 0 : 0.5 });
        this.state = 'closed';
    }

    open () {
        this.$el.classList.add('open');
        this.$el.classList.remove('closed');
        gsap.to(this.$el, {
            height:     'auto',
            duration:   0.5,
        });
        this.state = 'open';
    }

    // methods
    destroy () {
        this.title.removeEventListener('click', this.listener, true);
        this.open();
        super.destroy();
    }
}
